import React from 'react';
import CursorClickIcon from '@heroicons/react/outline/CursorClickIcon.js';
import { BlockType } from '../../types/index.js';
import { HeroBannerBlock as Component } from './Block.js';
import { HeroBannerBlockSettings as Settings } from './Settings.js';
export const RegisteredHeroBannerBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'HeroBanner',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.HeroBanner.DisplayName',
                defaultMessage: 'Hero Banner',
            }),
            Settings,
            Icon: React.createElement(CursorClickIcon, null),
            defaultProps: {
                title: $t({
                    id: 'Blocks.HeroBanner.DefaultTitle',
                    defaultMessage: 'Welcome to {COMMUNITY}',
                }),
                description: '',
                align: 'center',
                textColor: 'dark',
                imageTintOpacity: 0,
                imagePosition: 'cover',
                extraPadding: 3,
                style: 'card',
                backgroundType: 'image',
            },
        },
    };
};
//# sourceMappingURL=registered.js.map